import * as React from 'react';
import { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLogout, useRedirect } from 'react-admin';
import authProvider from '../auth/authProvider';
import { WHATSAPP_MODULE_ROLES } from '../roles/portalRoles';
import { isTokenExpired } from '../utils/jwtUtils';

const NotAuthorized = () => {
  const logout = useLogout();
  const redirect = useRedirect();

  const handleGoHome = () => {
    const token = localStorage.getItem('user_authToken');
    if (!token || isTokenExpired(token)) {
      logout();
      return;
    }

    if (authProvider.isRoleAuthorized(WHATSAPP_MODULE_ROLES)) {
      redirect('/messageinbox');
      return;
    }

    logout();
  };

  useEffect(() => {
    const token = localStorage.getItem('user_authToken');
    if (!token || isTokenExpired(token)) {
      logout();
    }
  }, [logout]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
      }}
    >
      <Typography variant="h5">Not authorized</Typography>
      <Typography color="text.secondary" align="center" sx={{ maxWidth: 420 }}>
        Your account does not have access to this Marketing portal section.
        Use an Admin or Marketing Admin account, or sign out and try again.
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button variant="contained" onClick={handleGoHome}>
          Go to Message Inbox
        </Button>
        <Button variant="outlined" onClick={() => logout()}>
          Log out
        </Button>
      </Box>
    </Box>
  );
};

export default NotAuthorized;
